<template lang="html">
  <div></div>
</template>

<script>
export default {
  name: 'CreateOwner'
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/CreateOwner.vue